import React, {useEffect, useState} from 'react';

import {useSelector} from 'react-redux';

import {
    Linking,
    StyleSheet,
    Text,
    TouchableOpacity,
    View,
} from 'react-native';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {globalConfigurableData, globalConst} from '../../../utils/globalConstant';
import {isMobile,} from '../../../utils/commonMethods';
import GoogleLoginRT from '../../../common/googleLogin';
import Width from '../../../assets/Width';
import FastImage from "../../../common/FastImage";
import { Icon } from '@iconify/react';

function PartnerLogin({
    mobileSigninReact,
    onCloseBtnClick
}) {
    const [error, setError] = useState('');
    const globalConfigData = useSelector(
        state => state.utilReducer.globalConfigData,
    );
    const termsAndCondition = globalConfigData?.termsAndCondition;
    const privacyPolicy = globalConfigData?.privacyPolicy;
    const amlPolicy = globalConfigData?.antiMoneyLaundering;

    const onLinkClick = (e, link) => {
        e.preventDefault();
        if (link) {
            Linking.openURL(link);
        }
    };


    const responseGoogleError = errorResponse => {
        setError(errorResponse?.error);
    };

    return (
        <View
            style={{
                height: Width.height,
                backgroundColor: globalConfigurableData.globalThemeColor,
            }}>
            <View
                style={{
                    paddingTop: 13,
                    paddingHorizontal: 16,
                    backgroundColor: globalConfigurableData.globalThemeColor,
                }}
            >
                <TouchableOpacity
                    onPress={() => {
                        onCloseBtnClick();
                    }}>
                    <Icon 
                        icon="tabler:arrow-left"
                        style={{ width: 24, height: 24 }}
                        color={globalConfigurableData.primaryTextColor1}
                    />
                </TouchableOpacity>

            </View>
            <View style={{
                justifyContent: 'center',
                paddingBottom: 100,
                flex: 1
            }}>
                <Text style={{
                    ...globalFontStyle.appFontTitleHead,
                    color: globalConfigurableData.primaryTextColor1,
                    textAlign: 'center'
                }}>
                    Welcome to Kostar
                </Text>
                <View
                    style={{
                        marginTop: 20,
                        paddingBottom: 15,
                        marginHorizontal: 16,
                    }}>
                    <View style={{marginTop: isMobile() ? 10 : 0}}>
                        <GoogleLoginRT
                            googleClientId={globalConst?.googleClientId}
                            responseGoogle={mobileSigninReact}
                            responseGoogleError={responseGoogleError}></GoogleLoginRT>
                    </View>
                    <View
                        style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginTop: 30,
                        }}>
                        <Text
                            style={{
                                ...globalFontStyle.appFontSmallText,
                                color: globalConfigurableData.tertiaryTextColor1,
                                flex: 1,
                                textAlign: 'center',
                            }}>
                            By contnuing, you agree to our
                            <Text
                                style={{
                                    ...globalFontStyle.appFontSmallText,
                                    color: globalConfigurableData.primaryBtnColor,
                                }}
                                onPress={e =>
                                    onLinkClick(
                                        e,
                                        privacyPolicy ||
                                        'https://tradexapp.zendesk.com/hc/en-us/articles/7198021845149-Privacy-Policy',
                                    )
                                }>
                                {' '}
                                Privacy Policy,{' '}
                            </Text>
                            <Text
                                className="app-font-small-text"
                                style={{
                                    ...globalFontStyle.appFontSmallText,
                                    color: globalConfigurableData.primaryBtnColor,
                                }}
                                onPress={e =>
                                    onLinkClick(
                                        e,
                                        termsAndCondition ||
                                        'https://tradexapp.zendesk.com/hc/en-us/articles/7197989869213-Terms-Conditions',
                                    )
                                }>
                                Terms{' '}
                            </Text>
                            &{' '}
                            <Text
                                className="app-font-small-text"
                                style={{
                                    ...globalFontStyle.appFontSmallText,
                                    color: globalConfigurableData.primaryBtnColor,
                                }}
                                onPress={e =>
                                    onLinkClick(
                                        e,
                                        amlPolicy ||
                                        'https://tradexapp.zendesk.com/hc/en-us/articles/11341149311261-Anti-Money-Laundering-Policy',
                                    )
                                }>
                                AML Policy.
                            </Text>
                        </Text>
                    </View>
                </View>

                {error !== null && error !== '' && (
                    <Text style={styles.loginErrorBar}>{error}</Text>
                )}
            </View>
        </View>
    );
}

export default React.memo(PartnerLogin);

const styles = StyleSheet.create({
    loginErrorBar: {
        ...globalFontStyle.appFontSubText,
        backgroundColor: globalConfigurableData.errorTextColor1,
        paddingVertical: 8,
        width: '100%',
        paddingLeft: 5,
        alignItems: 'center',
        color: globalConfigurableData.globalThemeColor,
    },
    inputDiv: {
        flexDirection: 'row',
        marginBottom: 10,
        paddingLeft: 0,
        borderRadius: 8,
        alignItems: 'center',
        borderColor: globalConfigurableData.borderColor,
        borderWidth: 1,
    },
});
